import { useSyncExternalStore } from "react";

/**
 * Which post (if any) is in sticker mode. Only one post at a time: opening
 * sticker mode on a post closes it on the previous one.
 */
let active: string | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const stickerModeStore = {
  get: () => active,
  set(postId: string | null) {
    if (active === postId) return;
    active = postId;
    emit();
  },
  toggle(postId: string) {
    stickerModeStore.set(active === postId ? null : postId);
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

export const useStickerModeActive = (postId: string) =>
  useSyncExternalStore(stickerModeStore.subscribe, () => active === postId, () => false);
